import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format'
import { parseISO } from 'date-fns'

@Pipe({
  name: 'fecha'
})
export class FechaPipe implements PipeTransform {

  transform(value: any, formato?: string, ...args: any[]): any {
    return this.toFecha(value, formato);
  }

  toFecha(value, formato?: string) {
    if (this.isNullDate(value)) return null;

    const conHora = this.isConHora(formato);
    const normalized = this.normalizeValue(value);

    const fechaSolo = this.formatFechaSoloSiAplica(value, normalized, conHora);
    if (fechaSolo !== null) return fechaSolo;

    const naiveLocal = this.formatNaiveLocalSiAplica(conHora, normalized);
    if (naiveLocal !== null) return naiveLocal;

    const parsed = this.formatParsedIsoSiAplica(normalized, conHora);
    if (parsed !== null) return parsed;

    return this.formatFallback(normalized, conHora);
  }

  private isNullDate(value: any): boolean {
    return !value || (typeof value === 'string' && value.startsWith('0001-01-01T'));
  }

  private isConHora(formato?: string): boolean {
    return formato === 'fechahora' || formato === 'datetime';
  }

  private normalizeValue(value: any): string {
    const raw = typeof value === 'string' ? value.trim() : '';
    return raw.replace(/^(\d{4}-\d{2}-\d{2})\s+/, '$1T');
  }

  private formatFechaSoloSiAplica(value: any, normalized: string, conHora: boolean): string | null {
    // Solo fecha "yyyy-MM-dd": parseISO usa medianoche UTC y desplaza la hora en zona local.
    if (typeof value !== 'string') return null;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return null;

    const y = Number(normalized.slice(0, 4));
    const mo = Number(normalized.slice(5, 7)) - 1;
    const d = Number(normalized.slice(8, 10));
    const localDate = new Date(y, mo, d);
    return format(localDate, conHora ? 'yyyy-MM-dd 00:00' : 'yyyy-MM-dd');
  }

  private formatNaiveLocalSiAplica(conHora: boolean, normalized: string): string | null {
    // Fecha-hora sin Z ni ±offset: convención del ERP = reloj local de oficina (timestamp sin zona en BD).
    // parseISO las trataría como UTC y desplazaría la hora en pantalla.
    if (!conHora) return null;

    const hasExplicitTz = /[zZ]$|[+-]\d{2}:\d{2}$/.test(normalized);
    if (hasExplicitTz) return null;

    const naiveLocal = normalized.match(
      /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?$/
    );
    if (!naiveLocal) return null;

    const y = Number(naiveLocal[1]);
    const mo = Number(naiveLocal[2]) - 1;
    const d = Number(naiveLocal[3]);
    const hh = Number(naiveLocal[4]);
    const mm = Number(naiveLocal[5]);
    const ss = naiveLocal[6] != null ? Number(naiveLocal[6]) : 0;
    const localDt = new Date(y, mo, d, hh, mm, ss);
    return format(localDt, 'yyyy-MM-dd HH:mm');
  }

  private formatParsedIsoSiAplica(normalized: string, conHora: boolean): string | null {
    try {
      return format(parseISO(normalized), conHora ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd');
    } catch {
      return null;
    }
  }

  private formatFallback(normalized: string, conHora: boolean): string | null {
    if (!normalized || normalized.length < 10) return null;

    const year = normalized.slice(0, 4);
    const month = normalized.slice(5, 7);
    const day = normalized.slice(8, 10);
    const date = new Date(Number(year), Number(month) - 1, Number(day));

    const dateString = format(date, conHora ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd');
    return dateString !== '1901-01-01' ? dateString : '';
  }

}
